import { format } from "date-fns";

export function formatDate(date) {
    if (date) {
        const formattedDate = format(new Date(date), "do MMMM yyyy, HH:mm")
        return formattedDate
    }
}